import clsx from 'clsx';

import type { Adaptive } from '../types/Adaptive';
import type { Height } from '../types/Height';

export function composeHeightClasses(height: Adaptive<Height>): string {
    if (typeof height === 'object') {
        return clsx(
            height.base && `h-${height.base}`,
            height.sm && `sm:h-${height.sm}`,
            height.md && `md:h-${height.md}`,
            height.lg && `lg:h-${height.lg}`,
            height.xl && `xl:h-${height.xl}`,
            height['2xl'] && `2xl:h-${height['2xl']}`
        );
    }

    return `h-${height}`;
}
